/**
 * TKP-27 / 6.4c-3 — kaldırılmış envanter kriterleri (backend `LegalDocumentCriteria` ile aynı). Kaynak envanter seviyesi
 * olmaktan çıktı; kütüphane şablonunda zorunlu işaretli kalsa da listelenmez ve hazır olmayı engellemez.
 */
export const RETIRED_CRITERIA = ["datasource"];

const active = (list) => (list || []).filter((i) => !RETIRED_CRITERIA.includes(i));

export const areRequiredCriteriasProvided = (requiredCriterias, criteria) =>
  active(requiredCriterias)
    .filter((i) => i != "organization")
    .every((i) => criteria && criteria[i] && criteria[i].length > 0);

/** Şablon listesindeki kriter özeti: zorunlular (sağlandı mı) ve zorunlu olmayan dolu kriterler. */
export const normalizeCriteria = (requiredCriterias, criteria, nameMap) => {
  const response = { others: [], required: [] };
  const required = active(requiredCriterias);
  const values = { ...(criteria || {}) };
  for (const i of Object.keys(values)) {
    if (i == "organization" || RETIRED_CRITERIA.includes(i)) continue;
    if (!required.includes(i) && values[i]?.length > 0) {
      response.others.push({ text: nameMap[i], value: values[i].map((v) => v.name) });
    }
  }
  for (const i of required) {
    if (i == "organization") continue;
    response.required.push({ text: nameMap[i], provided: values[i]?.length > 0, value: values[i]?.map((v) => v.name) });
  }
  return response;
};
